import { AnyAction } from 'redux';

import {
	BANK_VALIDATION_VALIDATE_IBAN,
	BANK_VALIDATION_VALIDATE_IBAN_CANCEL,
	BANK_VALIDATION_VALIDATE_IBAN_DONE,
	BANK_VALIDATION_VALIDATE_IBAN_FAILED,
} from '../../actions/bankValidation';
import {
	CONTRACT_PRICE_CALC, CONTRACT_PRICE_CALC_DONE, CONTRACT_PRICE_CALC_ERROR,
	CONTRACT_PRICE_MOB_FAILED,
	CONTRACT_PRICE_MOB_REFRESH,
	CONTRACT_PRICE_MOB_REFRESH_DONE,
} from '../../actions/contractPrices';
import {
	CONTRACT_SIGNATURE_REFRESH,
	CONTRACT_SIGNATURE_REFRESH_DONE,
} from '../../actions/contractSignature';
import {
	CONTRACT_WIZARD_CONTINUE,
	CONTRACT_WIZARD_CONTINUE_ERROR,
	CONTRACT_WIZARD_NEW,
	CONTRACT_WIZARD_NEXT_STEP,
	CONTRACT_WIZARD_PREVIOUS_FORM,
	CONTRACT_WIZARD_RESET_TO_STEP,
	CONTRACT_WIZARD_RESET_TO_STEP_DONE,
} from '../../actions/contractWizardActions';

import {
	STEP_AGREEMENT,
	STEP_AGREEMENT_KEH,
	STEP_CLIENT,
	STEP_CLIENT_DATA_1,
	STEP_CLIENT_DATA_2,
	STEP_INSURANCE,
	STEP_KPP_TERM,
	FORM_REVIEW_KEH,
	// STEP_SIGNATURE,
	STEP_TERM_KEH,
} from './constants';

import { getSteps, getForms } from './getForms';
import { ApiError } from 'types/api';
import {CONTRACT_FINALIZED_BY_EMAIL} from "../../actions/contractFinishByEmail";

const forms: string[] = [];
const steps: string[] = [];

export interface ContractWizardState {
	currentStep: number;
	steps: string[];
	currentForm: number;
	forms: string[];
	error: ApiError | undefined;
	isLoading: boolean;
}

const initialState: ContractWizardState = {
	steps,
	forms,
	currentStep: 0,
	currentForm: 0,
	error: undefined,
	isLoading: false,
};

function stepToForm(state: ContractWizardState, step: number): number {
	for (let i = 0; i < state.forms.length; i++) {
		if (formToStep(state, i) === step) {
			return i;
		}
	}

	return -1; // ERROR
}

function formToStep(state: ContractWizardState, form: number): number {
	const formName = state.forms[form];

	switch (formName) {
		case STEP_CLIENT_DATA_1:
		case STEP_CLIENT_DATA_2:
			return state.steps.indexOf(STEP_CLIENT); // review step
		case STEP_AGREEMENT: // case STEP_SIGNATURE: // 	return state.steps.indexOf(STEP_KPP_REVIEW);
		case STEP_AGREEMENT_KEH:
			return state.steps.indexOf(FORM_REVIEW_KEH);
		case STEP_KPP_TERM:
			return state.steps.indexOf(STEP_INSURANCE);
		case STEP_TERM_KEH:
			return state.steps.indexOf(STEP_INSURANCE);
		default:
			return state.steps.indexOf(formName);
	}
}

export function contractWizardReducer(
	state: ContractWizardState = initialState,
	action: AnyAction
): ContractWizardState {
	switch (action.type) {
		case CONTRACT_WIZARD_NEW:
			return {
				...initialState,
				steps: getSteps(action.payload),
				forms: getForms(action.payload),
			};
		case CONTRACT_WIZARD_CONTINUE:
			return {
				...state,
				error: undefined,
				isLoading: true,
			};
		case CONTRACT_WIZARD_NEXT_STEP:
			return {
				...state,
				currentForm: state.currentForm + 1,
				currentStep: formToStep(state, state.currentForm + 1),
				isLoading: false,
			};
		case CONTRACT_WIZARD_PREVIOUS_FORM:
			return {
				...state,
				currentForm: state.currentForm - 1,
				currentStep: formToStep(state, state.currentForm - 1),
				isLoading: true,
			};
		case CONTRACT_WIZARD_RESET_TO_STEP:
			return {
				...state,
				isLoading: true,
				currentForm: stepToForm(state, action.payload),
				currentStep: action.payload,
			};
		case CONTRACT_WIZARD_CONTINUE_ERROR:
			return {
				...state,
				isLoading: false,
				error: action.payload,
			};
		case BANK_VALIDATION_VALIDATE_IBAN: // Set and clear loading when validating IBAN externally
		case CONTRACT_SIGNATURE_REFRESH: // Set and clear loading when refreshing signature URL
		case CONTRACT_PRICE_MOB_REFRESH: // Set and clear loading when refreshing mob price
			return {
				...state,
				isLoading: true,
			};
		case '@@router/LOCATION_CHANGE':
		case BANK_VALIDATION_VALIDATE_IBAN_DONE:
		case BANK_VALIDATION_VALIDATE_IBAN_FAILED:
		case BANK_VALIDATION_VALIDATE_IBAN_CANCEL:
		case CONTRACT_WIZARD_RESET_TO_STEP_DONE:
		case CONTRACT_SIGNATURE_REFRESH_DONE:
		case CONTRACT_FINALIZED_BY_EMAIL:
		case CONTRACT_PRICE_MOB_REFRESH_DONE:
		case CONTRACT_PRICE_MOB_FAILED:
			return {
				...state,
				isLoading: false,
			};
		case CONTRACT_PRICE_CALC:
			return {
				...state,
				isLoading: true,
			};
		case CONTRACT_PRICE_CALC_DONE:
			return {
				...state,
				isLoading: false,
			};
		case CONTRACT_PRICE_CALC_ERROR:
			return {
				...state,
				isLoading: false,
			};
		default:
			return state;
	}
}
